import api from '@/apis/di/accountTransferAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('accountTransfer', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_account_transfer',
    field: {
      key: 'account_transfer_id',
      code: 'account_transfer_code',
      quickFollow: 'inactive', // NTLoc-2022/05/06 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
